import React from 'react'
import 'regenerator-runtime/runtime'
import LeaderBoard from '../../routes/LeaderBoard'
import { withHeaderOptions } from '../../hoc/withHeaderOptions'
import { DEFAULT_SUB_MENU, ROUTES } from '../../constants/navigation'
import {
  addDisableOverscroll,
  addRouteType,
  addSecondaryMenu
} from '../../utils/navigation'

const Leaders = () => {
  return <LeaderBoard />
}

export default withHeaderOptions(Leaders)(
  addSecondaryMenu(DEFAULT_SUB_MENU),
  addRouteType(ROUTES.COMMUNITY.EXPLORE),
  addDisableOverscroll()
)
